// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type CommonAiSuggestion_WithKgv2Fragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, kgV2Statements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: (
        { __typename?: 'KGV2Statement' }
        & AiSuggestion_Kgv2StatementWithNodesFragment
      ) | null } | null> | null }, sourceKgV2Nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: (
        { __typename?: 'KGV2Node' }
        & AiSuggestion_Kgv2NodeResolvedFragment
      ) | null } | null> | null } };

export type BaseKgv2NodeFragment = { __typename?: 'KGV2Node', id: string, nodeType: Types.Kgv2NodeNodeType, namePrimary: string, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null }, resolvedClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, displayName: string } | null } | null> | null }, resolvedClientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: { __typename?: 'ClientOrganization', id: string, name: string } | null } | null> | null }, resolvedTestamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null } | null> | null }, onboardingSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind } | null } | null> | null } };

export type BaseKgv2StatementFragment = { __typename?: 'KGV2Statement', id: string, predicate: string, value?: string | null, fact?: string | null, evidence: { __typename?: 'KGV2StatementEvidenceConnection', edges?: Array<{ __typename?: 'KGV2StatementEvidenceEdge', node?: (
        { __typename?: 'KGV2StatementEvidence' }
        & AiSuggestion_Kgv2StatementEvidenceFragment
      ) | null } | null> | null }, object?: (
    { __typename?: 'KGV2Node' }
    & BaseKgv2NodeFragment
  ) | null, subject: (
    { __typename?: 'KGV2Node' }
    & BaseKgv2NodeFragment
  ) };

export type AiSuggestion_Kgv2StatementEvidenceFragment = { __typename?: 'KGV2StatementEvidence', id: string, citation?: string | null, page?: number | null, snippet?: string | null, document: { __typename?: 'Document', id: string }, fileParagraphs?: Array<{ __typename?: 'FileParagraph', id: string, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }>, file?: { __typename?: 'File', id: string, pdfDocument?: { __typename?: 'Document', id: string } | null } | null }> | null };

export type AiSuggestion_Kgv2NodeResolvedFragment = { __typename?: 'KGV2Node', id: string, nodeType: Types.Kgv2NodeNodeType, namePrimary: string, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null }, resolvedClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, displayName: string } | null } | null> | null }, resolvedClientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: { __typename?: 'ClientOrganization', id: string, name: string } | null } | null> | null }, resolvedTestamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null } | null> | null }, onboardingSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind } | null } | null> | null }, statementsAsObject: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: (
        { __typename?: 'KGV2Statement' }
        & BaseKgv2StatementFragment
      ) | null } | null> | null }, statementsAsSubject: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: (
        { __typename?: 'KGV2Statement' }
        & BaseKgv2StatementFragment
      ) | null } | null> | null } };

export type AiSuggestion_Kgv2StatementWithNodesFragment = { __typename?: 'KGV2Statement', id: string, predicate: string, value?: string | null, fact?: string | null, evidence: { __typename?: 'KGV2StatementEvidenceConnection', edges?: Array<{ __typename?: 'KGV2StatementEvidenceEdge', node?: (
        { __typename?: 'KGV2StatementEvidence' }
        & AiSuggestion_Kgv2StatementEvidenceFragment
      ) | null } | null> | null }, subject: (
    { __typename?: 'KGV2Node' }
    & AiSuggestion_Kgv2NodeResolvedFragment
  ), object?: (
    { __typename?: 'KGV2Node' }
    & AiSuggestion_Kgv2NodeResolvedFragment
  ) | null };

export const Operations = {
  Fragment: {
    CommonAISuggestion_WithKGV2: 'CommonAISuggestion_WithKGV2' as const,
    BaseKGV2Node: 'BaseKGV2Node' as const,
    BaseKGV2Statement: 'BaseKGV2Statement' as const,
    AISuggestion_KGV2StatementEvidence: 'AISuggestion_KGV2StatementEvidence' as const,
    AISuggestion_KGV2NodeResolved: 'AISuggestion_KGV2NodeResolved' as const,
    AISuggestion_KGV2StatementWithNodes: 'AISuggestion_KGV2StatementWithNodes' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AiSuggestion_Kgv2StatementEvidenceFragmentDoc = gql`
    fragment AISuggestion_KGV2StatementEvidence on KGV2StatementEvidence {
  id
  citation
  page
  snippet
  document {
    id
  }
  fileParagraphs {
    id
    boundingRegions {
      PageNumber
      Polygon {
        x
        y
      }
    }
    file {
      id
      pdfDocument {
        id
      }
    }
  }
}
    `;
export const BaseKgv2NodeFragmentDoc = gql`
    fragment BaseKGV2Node on KGV2Node {
  id
  nodeType
  namePrimary
  resolvedEntities {
    edges {
      node {
        id
        kind
        subtype {
          id
          displayName
        }
      }
    }
  }
  resolvedClientProfiles {
    edges {
      node {
        id
        displayName
      }
    }
  }
  resolvedClientOrganizations {
    edges {
      node {
        id
        name
      }
    }
  }
  resolvedTestamentaryEntities {
    edges {
      node {
        id
        displayName
      }
    }
  }
  onboardingSuggestions {
    edges {
      node {
        id
        kind
      }
    }
  }
}
    `;
export const BaseKgv2StatementFragmentDoc = gql`
    fragment BaseKGV2Statement on KGV2Statement {
  id
  predicate
  value
  fact
  evidence {
    edges {
      node {
        ...AISuggestion_KGV2StatementEvidence
      }
    }
  }
  object {
    ...BaseKGV2Node
  }
  subject {
    ...BaseKGV2Node
  }
}
    ${AiSuggestion_Kgv2StatementEvidenceFragmentDoc}
${BaseKgv2NodeFragmentDoc}`;
export const AiSuggestion_Kgv2NodeResolvedFragmentDoc = gql`
    fragment AISuggestion_KGV2NodeResolved on KGV2Node {
  id
  nodeType
  namePrimary
  resolvedEntities {
    edges {
      node {
        id
        kind
        subtype {
          id
          displayName
        }
      }
    }
  }
  resolvedClientProfiles {
    edges {
      node {
        id
        displayName
      }
    }
  }
  resolvedClientOrganizations {
    edges {
      node {
        id
        name
      }
    }
  }
  resolvedTestamentaryEntities {
    edges {
      node {
        id
        displayName
      }
    }
  }
  onboardingSuggestions {
    edges {
      node {
        id
        kind
      }
    }
  }
  statementsAsObject {
    edges {
      node {
        ...BaseKGV2Statement
      }
    }
  }
  statementsAsSubject {
    edges {
      node {
        ...BaseKGV2Statement
      }
    }
  }
}
    ${BaseKgv2StatementFragmentDoc}`;
export const AiSuggestion_Kgv2StatementWithNodesFragmentDoc = gql`
    fragment AISuggestion_KGV2StatementWithNodes on KGV2Statement {
  id
  predicate
  value
  fact
  evidence {
    edges {
      node {
        ...AISuggestion_KGV2StatementEvidence
      }
    }
  }
  subject {
    ...AISuggestion_KGV2NodeResolved
  }
  object {
    ...AISuggestion_KGV2NodeResolved
  }
}
    ${AiSuggestion_Kgv2StatementEvidenceFragmentDoc}
${AiSuggestion_Kgv2NodeResolvedFragmentDoc}`;
export const CommonAiSuggestion_WithKgv2FragmentDoc = gql`
    fragment CommonAISuggestion_WithKGV2 on AISuggestion {
  id
  kind
  acceptanceStatus
  kgV2Statements {
    edges {
      node {
        ...AISuggestion_KGV2StatementWithNodes
      }
    }
  }
  sourceKgV2Nodes {
    edges {
      node {
        ...AISuggestion_KGV2NodeResolved
      }
    }
  }
}
    ${AiSuggestion_Kgv2StatementWithNodesFragmentDoc}
${AiSuggestion_Kgv2NodeResolvedFragmentDoc}`;